import { render } from "./changePhone.vue?vue&type=template&id=6d90392e&scoped=true"
import script from "./changePhone.vue?vue&type=script&lang=js"
export * from "./changePhone.vue?vue&type=script&lang=js"

import "./changePhone.vue?vue&type=style&index=0&id=6d90392e&lang=scss&scoped=true"
import "./changePhone.vue?vue&type=style&index=1&id=6d90392e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d90392e"]])

export default __exports__